import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import useAuthStore from '../store/authStore'
import clienteAxios from '../config/axios'

const usePageViewTracker = () => {
  const location = useLocation()
  const lastTracked = useRef(null)

  useEffect(() => {
    const key = location.pathname + location.search

    // Evitar duplicados si la ruta no cambió
    if (lastTracked.current === key) return
    lastTracked.current = key

    // Solo trackear si hay token (usuario autenticado)
    const token = useAuthStore.getState().token || localStorage.getItem('token')
    if (!token) return

    // Parsear query params
    const params = {}
    new URLSearchParams(location.search).forEach((value, key) => {
      params[key] = value
    })

    // Fire-and-forget: no bloquea la UI
    clienteAxios.post('/api/page-views', {
      route: location.pathname,
      params
    }).catch(() => {
      // Silencioso: no interrumpir al usuario si falla el tracking
    })
  }, [location])
}

export default usePageViewTracker
